import { uploadFile } from '@features/cms/components/content-type-editors/mutation-helper/file'

const DUMMY_IMAGE_PATH = '/dummy-image.png'

/**
 * Content types that should receive a dummy image on creation,
 * mapped to the upload key(s) used by their editor.
 */
const CONTENT_TYPE_IMAGE_KEYS: Record<string, string[]> = {
  image: ['image'],
  liveInteractionCard: ['image'],
  scratchCard: ['backgroundImage', 'foregroundImage'],
  comparisonSlider: ['image', 'overlay'],
}

const fetchDummyFile = async (): Promise<File> => {
  const res = await fetch(DUMMY_IMAGE_PATH)
  const blob = await res.blob()
  return new File([blob], 'dummy-image.png', { type: 'image/png' })
}

/**
 * Uploads the dummy image for a freshly created content item.
 * No-op when the content type has no primary image field.
 */
export const uploadDummyForContent = async (
  contentType: string,
  contentId: string
): Promise<void> => {
  const keys = CONTENT_TYPE_IMAGE_KEYS[contentType]
  if (!keys?.length) return

  const file = await fetchDummyFile()

  await Promise.all(
    keys.map((key) =>
      uploadFile({
        file,
        data: {
          key,
          replace: true,
          model: 'Content',
          modelId: contentId,
        },
      })
    )
  )
}

/**
 * Uploads the dummy image as keyvisual for a freshly created
 * ContentSection or ContentNugget.
 */
export const uploadDummyKeyvisual = async (
  model: 'ContentSection' | 'ContentNugget' | 'TourPoi',
  modelId: string
): Promise<void> => {
  const file = await fetchDummyFile()
  await uploadFile({
    file,
    data: {
      key: 'keyvisual',
      replace: true,
      model,
      modelId,
    },
  })
}
